import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

type BadgeType = 'status' | 'risk';

@Component({
  selector: 'app-state-badge',
  templateUrl: './state-badge.component.html',
  styleUrls: ['./state-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatIconModule],
})
export class StateBadgeComponent {
  @Input() status?: string | null;
  @Input() value?: string | null;
  @Input() type: BadgeType = 'status';
  @Input() showIcon = true;

  private normalize(value?: string | null): string {
    return (value || 'unknown').toLowerCase().replace(/\s+/g, '');
  }

  get normalizedValue(): string {
    return this.normalize(this.value ?? this.status);
  }

  get displayText(): string {
    return this.value ?? this.status ?? 'Unknown';
  }

  get badgeClass(): string {
    return `${this.type}-${this.normalizedValue}`;
  }

  get shouldShowIcon(): boolean {
    return this.type === 'status' && this.showIcon;
  }

  get icon(): string {
    switch (this.normalizedValue) {
      case 'completed':
      case 'approved':
      case 'success':
      case 'resolved':
      case 'confirmed':
        return 'check';

      case 'rejected':
      case 'cancelled':
      case 'failed':
      case 'revoked':
        return 'close';

      case 'processing':
      case 'processingonchain':
      case 'inprogress':
      case 'broadcasted':
        return 'sync';

      case 'overdue':
        return 'error';

      case 'pending':
      case 'awaitingapproval':
      case 'cancelling':
      default:
        return 'access_time';
    }
  }
}
